<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import AppIcon from '../components/AppIcon.vue'

const router = useRouter()
const agreed = ref(true)
</script>

<template>
  <section class="login-page">
    <div class="login-page__polygon"></div>
    <div class="login-card">
      <div class="roche-logo login-card__logo"><img src="/roche-logo.svg?v=20260819" alt="Roche" /></div>
      <p class="eyebrow">Reachinone 4.0</p>
      <h1>循证医学知识，<br />助力临床决策</h1>
      <p class="login-card__intro">面向医疗卫生专业人士的专业内容、问卷与医学信息服务平台。</p>
      <div class="login-card__trust">
        <AppIcon name="shield" />
        <span>医生身份认证 · 合规内容 · 全程可追溯</span>
      </div>
      <label class="consent-line">
        <input v-model="agreed" type="checkbox" />
        <span>我已阅读并同意《用户服务协议》和《隐私政策》</span>
      </label>
      <button class="primary-button login-card__button" :disabled="!agreed" @click="router.push('/identity')">
        微信安全登录
        <AppIcon name="arrow" />
      </button>
      <p class="login-card__footnote">登录后可访问与您专业身份匹配的内容与服务</p>
    </div>
    <aside class="login-story" aria-label="平台能力介绍">
      <span class="login-story__tag">HCP ENGAGEMENT</span>
      <h2>从专业内容到任务反馈，构建可信的 HCP 线上旅程</h2>
      <div class="login-story__steps">
        <span>01 身份与授权</span><span>02 合规内容</span><span>03 问卷与医学服务</span><span>04 行为反馈闭环</span>
      </div>
    </aside>
  </section>
</template>

<style scoped>
.login-page {
  position: relative;
  display: grid;
  min-height: 100vh;
  overflow: hidden;
  grid-template-columns: minmax(360px, 0.8fr) minmax(520px, 1.2fr);
  background: #fff;
}
.login-page__polygon { position: absolute; top: 0; right: 0; width: 56%; height: 100%; background: linear-gradient(131deg, #0b41cd 0 42%, #244fc0 42% 68%, #14358d 68%); clip-path: polygon(18% 0, 100% 0, 100% 100%, 0 100%, 22% 58%); }
.login-card { z-index: 2; display: flex; width: min(480px, calc(100% - 64px)); margin: auto; flex-direction: column; align-items: flex-start; }
.login-card__logo { margin-bottom: 44px; }
.login-card h1 { margin: 0; font-size: clamp(36px, 4vw, 56px); line-height: 1.16; }
.login-card__intro { max-width: 430px; margin: 20px 0 26px; color: var(--rio-muted); font-size: 16px; line-height: 1.7; }
.login-card__trust { display: flex; padding: 13px 16px; align-items: center; gap: 10px; border-radius: 10px; background: var(--rio-blue-soft); color: var(--rio-blue); font-size: 14px; }
.consent-line { display: flex; margin: 34px 0 18px; align-items: flex-start; gap: 10px; color: var(--rio-muted); font-size: 13px; line-height: 1.5; }
.consent-line input { width: 17px; height: 17px; accent-color: var(--rio-blue); }
.login-card__button { width: 100%; min-height: 52px; border: 0; }
.login-card__button:disabled { cursor: not-allowed; opacity: .45; }
.login-card__footnote { width: 100%; color: #8a8f99; font-size: 12px; text-align: center; }
.login-story { z-index: 2; display: flex; max-width: 690px; margin: auto; padding: 64px; flex-direction: column; color: white; }
.login-story__tag { font-size: 13px; font-weight: 700; letter-spacing: .16em; opacity: .78; }
.login-story h2 { max-width: 620px; margin: 24px 0 52px; font-size: clamp(36px, 4vw, 58px); line-height: 1.22; }
.login-story__steps { display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px; }
.login-story__steps span { border: 1px solid rgba(255,255,255,.32); padding: 18px; background: rgba(255,255,255,.08); }
@media (max-width: 820px) {
  .login-page { display: block; background: linear-gradient(160deg, #fff 0 70%, #eef4ff); }
  .login-page__polygon { width: 72%; height: 42%; opacity: .55; clip-path: polygon(44% 0,100% 0,100% 70%,76% 100%,0 48%); background: linear-gradient(131deg, transparent, rgba(189,227,255,.6)); }
  .login-card { min-height: 100vh; margin: 0 auto; padding: 36px 0; justify-content: center; }
  .login-card__logo { margin-bottom: 52px; }
  .login-card h1 { font-size: 34px; }
  .login-story { display: none; }
}
</style>
